import PropTypes from 'prop-types';
import { Skeleton } from '@aimsos/ui';

/**
 * Loading branch shared by every Data-step picker (CT-5191..5195).
 *
 * Split out of `PickerStates.jsx` (CT-5183 review) so the loading and error
 * branches each live in their own file, one component per file.
 */
export function PickerSkeleton({ count = 3, height = 56 }) {
  return (
    <div className="flex flex-col gap-2" aria-busy="true">
      {Array.from({ length: count }, (_, index) => (
        // Static, non-reorderable list with no id to key by — an index-based
        // key is acceptable here (see review note), prefixed to avoid clashing
        // with any real row key elsewhere in the tree.
        <Skeleton key={`picker-skeleton-${index}`} height={height} borderRadius={8} />
      ))}
    </div>
  );
}

PickerSkeleton.propTypes = {
  count: PropTypes.number,
  height: PropTypes.number,
};

export default PickerSkeleton;
